import TabConfPorSistema from './TabConfPorSistema'

function ConfigSectorSistemaGrupo() {
    return <TabConfPorSistema />
}

export default ConfigSectorSistemaGrupo
